import { z } from "zod";
import { FIELD_UPDATE_SOURCE } from "@common/constants";
import {
    accrualMonetaryAmountSchema,
    accrualNonnegativeMonetaryAmountSchema,
} from "@common/dto/financialDocument/accrual-document-extraction.schema";
import { InvoiceExtractionLineItemSchema } from "@common/schemas/financialDocument/invoice-extraction-line-item.schema";

export const AccrualExtractionBaseSchema = z.object({
    id: z.string().uuid(),
    documentInvoicesExtractionId: z.string().uuid(),
    orderIndex: z.number().int().min(0),
    counterpartyName: z.string().max(500).nullable(),
    counterpartyId: z.string().uuid().nullable(),
    counterpartyIdSource: z.nativeEnum(FIELD_UPDATE_SOURCE).nullish(),
    documentNumber: z.string().max(500).nullable(),
    documentDate: z.string().date().nullable(),
    dueDate: z.string().date().nullable(),
    totalAmount: accrualMonetaryAmountSchema.nullable(),
    taxAmount: accrualNonnegativeMonetaryAmountSchema.nullable().optional(),
    discountAmount: accrualNonnegativeMonetaryAmountSchema
        .nullable()
        .optional(),
    depositAmount: accrualNonnegativeMonetaryAmountSchema.nullable().optional(),
    memo: z.string().max(5000).nullable(),
    balanceDue: accrualMonetaryAmountSchema.nullable(),
    paymentDate: z.string().date().nullable(),
    entityId: z.number().int().nullable(),
    warnings: z.array(z.string().max(500)).max(50).nullable(),
});

export const InvoiceExtractionBaseSchema = AccrualExtractionBaseSchema;

export type InvoiceExtractionBase = z.infer<typeof InvoiceExtractionBaseSchema>;

export const InvoiceExtractionRecordSchema = InvoiceExtractionBaseSchema.omit({
    documentInvoicesExtractionId: true,
    orderIndex: true,
}).extend({
    lineItems: z.array(InvoiceExtractionLineItemSchema).max(500),
});

export type InvoiceExtractionRecord = z.infer<
    typeof InvoiceExtractionRecordSchema
>;
